var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: { id: "cancel_appointment_modal", "no-close-on-backdrop": true },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("cancelAppointmentModal.title"))),
              ]),
              _c(
                "button",
                {
                  attrs: { id: "cancel_appointment_modal_close_btn" },
                  on: { click: close },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "feather feather-x",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "17",
                        height: "17",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("line", {
                        attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                      }),
                      _c("line", {
                        attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-danger",
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("cancelAppointmentModal.submitBtn")) +
                      " "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "bb-form-group" },
        [
          _c("label", [
            _vm._v(
              _vm._s(_vm.$t("cancelAppointmentModal.messageInput.label")) + " "
            ),
            _c("span", { staticClass: "label-description" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("cancelAppointmentModal.messageInput.description")
                )
              ),
            ]),
          ]),
          _c("b-form-textarea", {
            staticClass: "bb-textarea",
            attrs: { rows: "3" },
            model: {
              value: _vm.form.fields.message,
              callback: function ($$v) {
                _vm.$set(_vm.form.fields, "message", $$v)
              },
              expression: "form.fields.message",
            },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.errors.message,
                  expression: "form.errors.message",
                },
              ],
              staticClass: "bb-invalid-feedback",
            },
            [_vm._v(" " + _vm._s(_vm.form.errors.message) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }